export class UpdateProfil {
  constructor(
    public profil: string,
    public statut_pro: string,
    public experience: string,
    public high_diploma: string,
    public domaine_specialisation: string,
    public a_monsujet: string
  ) {}
}
